export enum CouponActionTypes {
  POST_COUPON = 'POST_COUPON',
}
